import { StatusStepConfig, StatusBarConfig, StatusBarData } from '@/types/statusBar.types';
import statusBackgroundColor from '@/utils/json/statusBackgroundColor.json';

const statusBarData: StatusBarData = {
  STATUS_BAR: {
    statusSteps: {
      IN_PROGRESS: {
        stepNo: 1,
        tabIndex: 0,
        stepperBackgroundColor: statusBackgroundColor["in progress"],
        statusMap: [],
        path: "/create-product/shopping-list-management",
      },
      VENDOR_ASSESSMENT: {
        stepNo: 2,
        tabIndex: 1,
        stepperBackgroundColor: statusBackgroundColor["vendor assessment"],
        statusMap: [],
        path: "/create-product/vendor-assessment",
      },
      VENDOR_APPROVED: {
        stepNo: 3,
        tabIndex: 2,
        stepperBackgroundColor: statusBackgroundColor["vendor approved"],
        statusMap: [ "vendor_approved"],
        path: "/create-product/prepare-for-panel",
      },
      AWAITING_BUSINESS_REVIEW: {
        stepNo: 4,
        tabIndex: 3,
        stepperBackgroundColor: statusBackgroundColor["awaiting business review"],
        statusMap: ["awaiting_business_review", "need_more_information"],
        path: "/panel/business-review-panel",
      },
      READY_FOR_TASTING_PANEL: {
        stepNo: 5,
        tabIndex: 4,
        stepperBackgroundColor: statusBackgroundColor["ready for tasting panel"],
        statusMap: [
          "ready_for_tasting_panel",
         
          "tasting_panel_approved",
          "needs_revision",
        ],
        path: "/panel/tasting-panel",
      },
      TASTING_PANEL_APPROVED: {
        stepNo: 6,
        tabIndex: 4,
        stepperBackgroundColor: statusBackgroundColor["tasting panel approved"],
        statusMap: [
          "ready_for_tasting_panel",
       
          "tasting_panel_approved",
          "needs_revision",
        ],
        path: "",
      },
      VENDOR_INFORMATION_REQUESTED: {
        stepNo: 7,
        tabIndex: 0,
        stepperBackgroundColor: statusBackgroundColor["vendor information requested"],
        statusMap: [],
        path: "",
      },
      PARTIALLY_SUBMITTED: {
        stepNo: 8,
        tabIndex: 0,
        stepperBackgroundColor: statusBackgroundColor["partially submitted"],
        statusMap: [],
        path: "",
      },
      UNDER_PRODUCT_DEVELOPER_REVIEW: {
        stepNo: 9,
        tabIndex: 0,
        stepperBackgroundColor: statusBackgroundColor["under product developer review"],
        statusMap: [],
        path: "",
      },
      UNDER_INTERNAL_REVIEW: {
        stepNo: 10,
        tabIndex: 0,
        stepperBackgroundColor: statusBackgroundColor["under internal review"],
        statusMap: [],
        path: "",
      },
      UNDER_LEGAL_REVIEW: {
        stepNo: 11,
        tabIndex: 0,
        stepperBackgroundColor: statusBackgroundColor["under legal review"],
        statusMap: [],
        path: "",
      },
      ARTWORK_IN_DESIGN: {
        stepNo: 12,
        tabIndex: 0,
        stepperBackgroundColor: statusBackgroundColor["artwork in-design"],
        statusMap: [],
        path: "",
      },
      FINAL_SPECIFICATION_REVIEW_AND_ACKNOWLEDGEMENT_VENDOR: {
        stepNo: 13,
        tabIndex: 0,
        stepperBackgroundColor: statusBackgroundColor["final specification review and acknowledgement - vendor"],
        statusMap: [],
        path: "",
      },
      FINAL_SPECIFICATION_REVIEW_AND_APPROVAL_TJ: {
        stepNo: 14,
        tabIndex: 0,
        stepperBackgroundColor: statusBackgroundColor["final specification review and approval - tj"],
        statusMap: [],
        path: "",
      },
      READY_FOR_ORDERS: {
        stepNo: 15,
        tabIndex: 0,
        stepperBackgroundColor: statusBackgroundColor["ready for orders"],
        statusMap: [],
        path: "",
      },
      TO_BE_DISCONTINUED: {
        stepNo: 16,
        tabIndex: 0,
        stepperBackgroundColor: "#FCCBB1",
        statusMap: ["to_be_discontinued"],
        path: "",
      },
      DISCONTINUED: {
        stepNo: 17,
        tabIndex: 0,
        stepperBackgroundColor: "#D6E1FF",
        statusMap: ["discontinued"],
        path: "",
      },
      SUPERSEDED: {
        stepNo: 18,
        tabIndex: 0,
        stepperBackgroundColor: statusBackgroundColor["superseded"],
        statusMap: ["superseded"],
        path: "",
      },
    },
    statusLabelMap: {
      ACTIVE: "In Progress",
      ARCHIVED: "Archived",
      ON_HOLD: "On Hold",
      HOLD: "On Hold",
      NEED_MORE_INFORMATION: "Need More Information",
      NEEDS_REVISION: "Needs Revision",
      IN_PROGRESS: "In Progress",
      VENDOR_ASSESSMENT: "Vendor Assessment",
      VENDOR_APPROVED: "Vendor Approved",
      AWAITING_BUSINESS_REVIEW: "Awaiting Business Review",
      READY_FOR_TASTING_PANEL: "Ready for Tasting Panel",
      TASTING_PANEL_APPROVED: "Tasting Panel Approved",
      VENDOR_INFORMATION_REQUESTED: "Vendor Information Requested",
      PARTIALLY_SUBMITTED: "Partially Submitted",
      UNDER_PRODUCT_DEVELOPER_REVIEW: "Under Product Developer Review",
      UNDER_INTERNAL_REVIEW: "Under Internal Review",
      UNDER_LEGAL_REVIEW: "Under Legal Review",
      ARTWORK_IN_DESIGN: "Artwork In-Design",
      FINAL_SPECIFICATION_REVIEW_AND_ACKNOWLEDGEMENT_VENDOR: "Final Specification Review and Acknowledgement - Vendor",
      FINAL_SPECIFICATION_REVIEW_AND_APPROVAL_TJ: "Final Specification Review & Approval - TJ",
      READY_FOR_ORDERS: "Ready For Orders",
      TO_BE_DISCONTINUED: "To be Discontinued",
      DISCONTINUED: "Discontinued",
      SUPERSEDED: "Superseded",
      NOT_PROGRESSED: "Not Progressed",
    },
    statusColorMap: {
      IN_PROGRESS: statusBackgroundColor["in progress"],
      ON_HOLD: statusBackgroundColor["on hold"],
      HOLD: statusBackgroundColor["on hold"],
      ARCHIVED: statusBackgroundColor["archived"],
      NEED_MORE_INFORMATION: statusBackgroundColor["need more information"],
      NEEDS_REVISION: statusBackgroundColor["needs revision"],
      NOT_PROGRESSED: statusBackgroundColor["not progressed"],
    },
    inactiveStepColor: "#F3F4F6",
  },
};

export default statusBarData;


